import React from 'react';
import { useParams } from 'react-router-dom';
import Navbar from '../components/Internal-nav';  
import SinkData from '../data/sinkdata.json';
import './sink-detail.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMobileAlt } from '@fortawesome/free-solid-svg-icons';
import SEO from '../components/SEO';
import StructuredData from '../components/StructuredData';

function SinkDetail() {
    const { slug } = useParams();
    var val = slug;
    var sink = SinkData.Sinks.filter(function(item) {
        return item.url === val;
    });

    const sinkData = sink[0];
    const fullDescription = `${sinkData.productName} - ${sinkData.features?.map(f => f.feature).join('. ')}`;
    const keywords = `kitchen sinks, bathroom sinks, ${sinkData.productName}, ${sinkData.material || ''}`;

    return (
        <div className='App'>
            <SEO 
                title={sinkData.productName}
                description={fullDescription}
                keywords={keywords}
                canonicalUrl={`https://bcsupply.com/sinks/${slug}`}
                ogImage={sinkData.imageurl}
            />
            <StructuredData 
                productData={{
                    name: sinkData.productName,
                    description: fullDescription,
                    image: sinkData.imageurl,
                    brand: sinkData.brand,
                    price: sinkData.price,
                    inStock: true,
                    manufacturer: sinkData.manufacturer
                }}
                productType="Kitchen Sink"
            />
            <header>
                <Navbar />
            </header>

            <div className='sink-detail'>
                <div className='detail-left'>
                    <img className='large-product' src={sinkData.imageurl} alt={sinkData.altText} />
                    <div className='quote-request'>
                        <h3>Call Today to Get a Quote</h3>
                        <a href="tel:2603213092" className='quote-button'>
                            <FontAwesomeIcon icon={faMobileAlt} /> (260) 321-3092
                        </a>
                    </div>
                </div>

                <div className='detail-right'>
                    <h2>{sinkData.productName}</h2>
                    <div className='feature-section'>
                        <h3>Features</h3>
                        <ul className='features'>
                            {sinkData.features ? 
                                sinkData.features.map((d,i) => (
                                    <li key={i}>{d.feature}</li>
                                ))
                                : 'loading'}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SinkDetail;